import React, { useEffect, useRef } from "react";
import PaymentForm from "../../components/PaymentForm/PaymentForm";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  pushEvent,
  hotelCartItems,
  hotelCartValue,
  restaurantItemsFromState,
} from "../../utils/datalayer";

function Payment() {
  const { reservationType, orderId, totalAmountToBlock } = useSelector(
    (state) => state.bookingParam
  );
  const bookingParam = useSelector((s) => s.bookingParam);
  const restaurant = useSelector((s) => s.restaurant);
  const restaurantHotel = useSelector((s) => s.restaurantHotel);
  const hotelSettings = useSelector((s) => s.settings.hotelSettings);
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const fired = useRef(false);

  if (!orderId.length) {
    location.pathname.includes("hotel")
      ? navigate(`/hotel`)
      : navigate(`/restaurant`);
  }

  useEffect(() => {
    if (fired.current) return;
    if (!orderId || !orderId.length) return;

    const isRestaurantOnly = reservationType === "R" ||
      (typeof location.pathname === "string" &&
        location.pathname.includes("restaurant/payment"));

    const deposit = Number(
      (hotelSettings && hotelSettings.secure_restaurant_amount) || 0,
    );

    let items = [];
    let value = Number(bookingParam.totalPrice) || 0;

    if (isRestaurantOnly) {
      items = restaurantItemsFromState(restaurant, deposit);
      if (!value) value = Number(bookingParam.totalAmountToBlock) || 0;
    } else {
      const nights = bookingParam.totalNights || 1;
      const rooms = bookingParam.rooms || [];
      items = hotelCartItems(rooms, nights);
      const restItems = restaurantItemsFromState(restaurantHotel, deposit);
      if (restItems.length) items = items.concat(restItems);
      if (!value) value = hotelCartValue(rooms, nights);
    }

    if (!items.length && !value) return;
    pushEvent("add_payment_info", items, value, { payment_type: "card" });
    fired.current = true;
  }, [orderId, reservationType, bookingParam, restaurant, restaurantHotel, hotelSettings, location.pathname]);

  return (
    <>
      {reservationType.length && (
        <div className="mb-36 flex flex-col gap-5 md:justify-around col-span-2 bg-white border rounded p-7">
          <p className="mx-7 2xl:mx-20 font-semibold mt-2 text-red-600 text-center">
            {location.pathname.includes("restaurant/payment") ||
              reservationType === "R"
              ? `${t("payment_resto_msg", {
                totalAmountToBlock: totalAmountToBlock,
              })}`
              : location.pathname.includes("hotel/payment") ||
                reservationType === "H"
                ? `${t("payment_hotel_msg", {
                  totalAmountToBlock: totalAmountToBlock,
                })}`
                : `${t("payment_hotel_msg", {
                  totalAmountToBlock: totalAmountToBlock,
                })}`}
          </p>
          <p></p>
          <PaymentForm />
          {location.pathname.includes("restaurant/payment") ||
            reservationType === "R" ? (
            <div>
              <p id="para" className="2xl:text-sm text-xs mt-2">
                {t("rest_garantee_conditions")}
              </p>
              <p className="text-sm mt-2">
                {t("accept_conditions_check")}<br />
                <a
                  href="https://villarenelalique.com/fr/conditions-generales-de-vente.html"
                  target="_blank"
                  rel="noreferrer"
                  className="underline text-primary ml-1"
                >
                  {t("link_cgv")}
                </a>
              </p>
            </div>
          ) : (
            <div>
              <p id="para" className="2xl:text-sm text-xs mt-2">
                {t("hotel_garantee_conditions")}
              </p>
              <p className="text-sm mt-2">
                {t("accept_conditions_check")}<br />
                <a
                  href="https://villarenelalique.com/fr/conditions-generales-de-vente.html"
                  target="_blank"
                  rel="noreferrer"
                  className="underline text-primary ml-1"
                >
                  {t("link_cgv")}
                </a>
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default Payment;